function makeListWithEditable(list: Array<any>, editableKey: string) {
  return list.map(item => {
    let editable = false;

    if (item.name.includes(editableKey)) {
      editable = true;
    }

    return { ...item, editable: editable };
  });
}

function asuhanItemKey(item: any): string {
  const name = String(item && item.name ? item.name : "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

  const isEditable = Boolean(item && item.editable) || name.includes(".....");

  if (item == null || item.id == null || isEditable) {
    return `n:${name}`;
  }

  return `i:${item.id}`;
}

function dedupeAsuhanItems(list: any[]): any[] {
  const seen: Record<string, boolean> = {};

  return (list || []).filter(item => {
    const key = asuhanItemKey(item);

    if (seen[key]) {
      return false;
    }

    seen[key] = true;

    return true;
  });
}

const PPJA_ONLY_HINT =
  "Khusus PPJA";

export {
  makeListWithEditable,
  asuhanItemKey,
  dedupeAsuhanItems,
  PPJA_ONLY_HINT
};
